import { z } from 'zod';

export const ClientAccountPickerModalSchema = z.object({
  accountId: z.string().min(1),
});

export type ClientAccountPickerModal = z.infer<
  typeof ClientAccountPickerModalSchema
>;
